<template>
    <div class="captcha-wrap">
        <van-field
            v-model="val"
            name="图片验证码"
            label="图片验证码"
            placeholder="图片验证码"
            :rules="[
                { required: true,  trigger: 'blur' ,message: '请输入图片验证码'},
            ]"
        >
            <template #button>
                <van-image
                    class="captcha-img"
                    :src="captchaUrl"
                    @click="changeCaptcha"
                    height="100%"
                />
            </template>
        </van-field>

    </div>
</template>

<script>
import {getCaptcha} from "@/api/CommonApi";
import {generateMixed} from "@/utils/stringUtils";

export default {
    name: "captcha",
    props:{
        captcha:{
            type:Object,
            require:true,
        }
    },
    data(){
        return{
            captchaUrl:'',
        }
    },
    computed:{
        val:{
            get(){
                return this.captcha.value
            },
            set(v){
                // eslint-disable-next-line vue/no-mutating-props
                this.captcha.value = v
            }
        }
    },
    created() {
        this.changeCaptcha()
    },
    methods:{
        changeCaptcha() {
            const key = generateMixed(15)
            // eslint-disable-next-line vue/no-mutating-props
            this.captcha.key = key
            // eslint-disable-next-line vue/no-mutating-props
            this.captcha.value = ''
            getCaptcha(key).then(res => {
                this.captchaUrl = res.result
            })
        },
    }
}
</script>

<style scoped>
.captcha-wrap{
    /*display: flex;*/
    /*justify-content: space-between;*/
    /*align-items: center;*/
    /*padding-right: 10px;*/
}
.captcha-img{
    vertical-align: top;
}
</style>
